module.exports = __webpack_public_path__ + "static/media/DummyContractMobile.ad6eba5c.png";